<template>

  <v-dialog
    v-model="show"
     transition="dialog-bottom-transition"
    persistent
    :width="action=='new'?'640':'99%'"
    >
    <div style="background: #f0f0f0; padding: 6px;">
    <v-toolbar class="ma-1"  dense  elevation="0" rounded>
            <v-icon left >mdi-playlist-plus</v-icon><span class="va-underline">{{action=='new'?'New':'Modify'}} Product </span>
            <v-spacer/>
            <v-btn fab x-small elevation="1" color="warning"  @click="emitToParent('close')"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
    <v-row no-gutters>
      <v-col :cols="action=='new'?'12':'4'">
          <v-card class="ma-1">
            <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                    <v-text-field
                      v-model="product.name"
                      outlined
                      @change="validateName()"
                      dense
                      :rules="FieldRules('Please enter a product name')"
                      label="Product Name"
                    />
                    <v-text-field
                      outlined
                      dense
                       v-model="product.code"
                      label="Product Code"
                    />
                    <v-select
                    v-model="product.type"
                      :items="types"
                      label="Category"
                      :rules="FieldRules('Select category')"
                      outlined
                      dense
                      persistent-hint
                      hint="Manage categories in Setting Page."
                    ></v-select>
                    <v-textarea
                      outlined
                      class="mt-3"
                       rows="2"
                       v-model="product.description"
                      label="Description"
                      dense
                    />
                    Properties <v-icon right color="primary" small @click="showprop = true">mdi-{{action=='new'?'plus-box-outline':'pencil-outline'}}</v-icon>
                    <p class="def-font">Product properties refer to the specific characteristics, features, or attributes that define a product
                      <a @click="INFO()">learn more...</a></p>
                    <v-row no-gutters class="mb-4">
                      <v-flex v-for="(item, index) in product.properties" :key="index" >
                          <v-btn  small tile elevation="1" class="mb-1" block> {{item.name}}</v-btn>
                      </v-flex>
                    </v-row>

                   
                    <v-combobox
                      v-model="product.tags"
                      label="Product tags"
                      flat
                      labels
                      dense
                      chips
                      multiple
                      :rules="FieldRules('Please enter a product tags')"
                      
                    ></v-combobox>

                    <v-select
                    v-model="product.status"
                      :items="['Available', 'Not Available']"
                      label="Status"
                      :rules="FieldRules('Select status')"
                      outlined
                      dense
                    ></v-select>

                  <v-select
                    v-model="product.track"
                      :items="['Track Inventory', 'Not Applicable']"
                      label="Tracking"
                      :rules="FieldRules('Select status')"
                      outlined
                      persistent-hint
                      hint="Set to (Not Applicable) for Service type product."
                      dense
                    ></v-select>

                    <v-divider class="mb-2"/>
                  <div >
                    <p>Product Images</p>
                    <zera-s3-upload :show="s3upload" @zeraEvent="s3Ev"/>
                    <div v-if="product.images.length" class="preview-container">
                      <span v-for="(image, index) in ViewUploadedfiles(product.images)" :key="index" class="image-preview">
                      <img :src="image" alt="Preview"    @click="imgsrc = image, imgview=true" class="_link" />
                      </span>
                  </div>
                  </div>  
                  
                 
             </v-form>
             </v-card-text> 
          </v-card>
      </v-col>
        <v-col cols="8" v-if="action!='new'">
          <v-card class="ma-1">
            <v-toolbar class="ma-1"  dense  elevation="0" rounded>
             <v-icon left>mdi-format-list-checkbox</v-icon> Product Variants
              <v-divider vertical class="ml-2"/>
            <v-btn text small color="primary" @click="skustate='new',showsku=true"><v-icon left >mdi-plus</v-icon>ADD</v-btn>
           
            <!-- <v-btn text small @click="showprop = true"><v-icon left >mdi-cog</v-icon>Properties</v-btn> -->
          </v-toolbar>
              <v-card-text v-if="product_items.length > 0">
                <table class="va-table prop-item">
                  <tr>
                    <th>SKU ID</th>
                    <th>Properties</th>
                    <th>Unit</th>
                    <th>Cost</th>
                    <th>Selling Price</th>
                    <th v-if="Track(product.track)">Stock</th>
                    <th>Sold</th>
                    <th>Status</th>
                  </tr>
                  <tr v-for="(item, index) in product_items" :key="index">
                    <td class="text-left">  
                      <v-icon class="va_hover" :id="'menu-activator-sk-'+index" small  color="warning">mdi-menu</v-icon>
                      <v-menu :activator="'#menu-activator-sk-'+index" offset-y>
                        <div style="width: 150px">
                        <v-btn color="#fff" tile elevation="2" block small @click="skustate='update',selected_item=item,showsku=true">Modify</v-btn>
                        
                        <v-btn color="#fff" tile elevation="2" block small 
                        v-for="(status, s) in product_statuses" :key="s"
                        @click="item.status=status, saveItem(item)"
                        >
                          {{status}}
                        </v-btn>
                        
                      </div>
                      </v-menu>

                       {{item.id}}
                      </td>
                    <td class="text-left">
                        <v-row no-gutters>
                        <v-col cols="6"  label v-for="(prop, i) in item.properties" :key="i" class="prop-list">
                          {{prop.name}} : {{prop.value}}
                        </v-col>
                      </v-row>
                    </td>
                 
                    <td>{{item.unit}}</td>
                    <td>{{$money(item.cost)}}</td>
                    <td>{{$money(item.selling_price)}}</td>
                    <td v-if="Track(product.track)">{{$count(item.stock)}}</td>
                    <td>{{$count(item.sold)}}</td>
                    <td>{{item.status}}</td>
                  </tr>
                </table>
              </v-card-text>
              <v-card-text class="text-center" v-else>
                          <div class="font-weight-thin font-italic pa-5 mt-5"  >
                            <a @click="skustate='new',showsku=true">Add your first variants for {{product.name}}...  <v-icon  right small color="primary">mdi-pencil</v-icon></a>
                          </div>
                    </v-card-text>
              
          </v-card>
        </v-col>

    </v-row>     
       <v-bottom-navigation  v-if="bottomNav" class="animate__animated animate__backInUp">
      
      <v-btn  @click="emitToParent('close')">
        <v-icon>mdi-close</v-icon>

        <span>Close</span>
      </v-btn>

      <v-btn value="nearby"  @click="validate()" color="success" :disabled="disabled">
        <v-icon color="#fff">mdi-{{action=='new'?'note-plus-outline':'check'}}</v-icon>

        <span class="text-white">{{action=='new'?'Add Product':'Modify'}}</span>
      </v-btn>
    </v-bottom-navigation> 
  </div>

 

    <va-sku-form :show="showsku" :state="skustate" :item="selected_item" :data="product" @DialogEvent="skuEv"/>
    <va-product-properties :show="showprop" :state="action" :data="product" @DialogEvent="propEv"/>
    <zera-image-viewer :show="imgview" :imgsrc="imgsrc" @DialogEvent="imgview = false"/>
  </v-dialog>

</template>

<script>
 import {
   mapMutations
 } from 'vuex'
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selectedID: {
       type: Number,
        default: null
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      imgview: false,
      showprop: false,
      showsku: false,
      skustate:'new',
      valid: true,
      bottomNav: false,
      s3upload: false,
      newpassword:'',
      disabled: false,
      loading: false,
      product: {images:[]},
      latlong:{},
      franchiselist:[],
      product_statuses:[],
      product_items:[],
      productID:0,
      types: [],
      action: 'new',
      selected_item:{}
  }),
  computed: {

  },
  watch: {
    show (v) {
      if (v) {
          this.product_statuses = this.GET_SYSVARS('product_status')
          this.types = this.GET_SYSVARS('product_types')
          this.action = this.state
          
          if(this.action != 'new') {
            this.productID = this.selectedID
            this.bottomNav = true
            this.s3upload = true
            this.getProduct()
          }
      }  else {  
        this.disabled=false
        this.bottomNav = false
        this.product_items =[]
        this.$refs.form.reset()
        this.setActionAlert({show: false, text: ""});
      }
    
    }
  },
  methods: {
    ...mapMutations(['setActionAlert']),
    
    skuEv(){
      this.showsku = false
      this.getItems()
    },
    propEv(props){
      this.showprop = false
      if(this.action == 'new') {
          this.product.properties = props
      } else {
        this.getProduct()
      }
      
    },
    validateName(){
     if(this.product.name.length > 1) {
      this.s3upload = true
      this.bottomNav = true
     }
     
    },
    validate () {
       
        if (this.$refs.form.validate()) {
            if(this.action=='new') {
              this.addProduct()
            } else {
              this.updateProduct()
            }
            
        }
      },
      s3Ev(e){
        this.s3upload = false
        if(this.product.images == null) {
          this.product.images = e
        } else {
          this.product.images = this.product.images.concat(e);
        }
      },
      saveItem(item){
   
           let params = {
            table: "product_items", 
            type:"newdata",
            query:`update product_items set modified_on=NOW(), status='${item.status}' where id=${item.id}`
        }
   
        this.$http.post("new_data", params).then(response => {
          console.log(response)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
         this.getItems()
        }).catch(e => {
          console.log(e.data)
        })
    },
      getItems(){
        this.GET_PRODUCT_ITEMS(this.productID, (res)=>{
          console.log("results_items", res.results)
          if(res.results.length>0){
            this.product_items = res.results
          }
          console.log("product_items", this.product_items)
        })
      },
      getProduct(){
        this.VA_ALERT('info', 'Loading product...', 'progress', 100, 2000)
        this.SINGLE_PRODUCT(this.productID, (res)=>{
          console.log(res)
          if(res.results){
            this.product = res.results[0]
            if(!this.product.images) {
              this.product.images =[]
            }
            this.getItems()
          }
        })
      },
      addProduct() { 
        this.disabled=true
        console.log("New product", this.product)
        this.product.added_by = this.$IsNum(this.$session.get('userID'))
        
        this.$http.post("new_product", this.product).then(response => {
          console.log("add", response)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          this.disabled=false
          if(response.data.status){
          this.emitToParent()
          }
        }).catch(e => {
          this.disabled=false
          console.log(e.data)
        })
     },
     updateProduct() { 
        this.disabled=true
        
        this.product.added_by = this.$IsNum(this.$session.get('userID'))
        
        this.$http.post("update_product", this.product).then(response => {
          console.log("add", response)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          this.disabled=false
          if(response.data.status){
           this.emitToParent()
          }
        }).catch(e => {
          this.disabled=false
          console.log(e.data)
        })
     },
    //  updateProduct() { 
    //     this.disabled=true
    //     console.log("New product", this.product)
    //     let params = {
    //         table: "products", 
    //         type:"newdata",
    //         query:`update products set name='${this.product.name}', 
    //         code='${this.product.code}', 
    //         description='${this.product.description}', 
    //         modified_on=NOW(), 
    //         images='${JSON.stringify(this.product.images)}'::jsonb, 
    //         status='${this.product.status}', 
    //         tags='${JSON.stringify(this.product.tags)}'::jsonb,
    //         properties='${JSON.stringify(this.product.properties)}'::jsonb,
    //         type='${this.product.type}' where id=${this.productID}`
    //     }

    //     this.$http.post("new_data", params).then(response => {
    //       console.log("add", response.data)
    //       this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
    //       this.disabled=false
    //       if(response.status){
    //       this.emitToParent()
    //       }
    //     }).catch(e => {
    //       this.disabled=false
    //       console.log(e.data)
    //     })
    //  },
      emitToParent () {
        this.s3upload = false
        this.loading=false
        
          setTimeout(()=>{
            this.product = {images:[]}
             this.$emit('DialogEvent', "")
          },200)
         
      }
  }
}
</script>
